import { useMemo } from 'react'
import PageTypeIdentifier, { pageTypes } from '@usap/carparts/src/shared/helpers/PageTypeIdentifier'

const useBreadcrumbClickHandlers = links => useMemo(() => {
  if (links.length < 1) return []

  return links.map((_, index) => () => {
    if (!__BROWSER__) return null

    if (window?.pageType === pageTypes.MAKE_PART && index === 1) {
      return PageTypeIdentifier.make()
    }

    if (window?.pageType === pageTypes.BRAND_PART && index === 1) {
      return PageTypeIdentifier.brand()
    }

    if (window?.pageType === pageTypes.MMP || window?.pageType === pageTypes.YMM || window?.pageType === pageTypes.YMMP) {
      if (index === 1) return PageTypeIdentifier.make()
      if (index === 2) return PageTypeIdentifier.makeModel()
    }

    return null
  })
}, [links])

export default useBreadcrumbClickHandlers
